import { IAmountDetailsFormState, ICustomAmountDetailsFormState } from "../components/Transactions/Components/Form/Fields/AmountDetails/AmountDetailsField";
import { convertAmountToFloat } from "./transaction_helpers";

export const sumValues = (data: IAmountDetailsFormState): number => {
    let sum = (
        convertAmountToFloat(data.good_price || '0') +
        convertAmountToFloat(data.shipping_fee || '0') +
        convertAmountToFloat(data.customs_fee || '0') +
        convertAmountToFloat(data.other_fee || '0')
    );
    (data.custom || []).forEach((item: ICustomAmountDetailsFormState) => {
        sum += convertAmountToFloat(item.value || '0');
    });
    
    return sum;
};
